import { Routes, Route, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Breadcrumb from './components/Breadcrumb';
import SiteUpgrade from './components/SiteUpgrade';
import ContactPage from './components/ContactPage';
import ServicesPage from './components/ServicesPage';
import ServiceDetailPage from './components/ServiceDetailPage';
import GalleryPage from './components/GalleryPage';


function App() {
  const location = useLocation();

  // ✅ NEW: store current service title for breadcrumb
  const [serviceTitle, setServiceTitle] = useState(null);

  useEffect(() => {
    if (!location.pathname.startsWith('/services/')) {
      setServiceTitle(null);
    }
  }, [location.pathname]);

  const getBreadcrumbItems = () => {
    const path = location.pathname;

    // Home only
    if (path === '/') {
      return [{ label: 'Home' }];
    }

    // Services index
    if (path === '/services') {
      return [
        { label: 'Home', link: '/' },
        { label: 'Our Services' },
      ];
    }

    // Service detail (dynamic)
    if (path.startsWith('/services/')) {
      return [
        { label: 'Home', link: '/' },
        { label: 'Our Services', link: '/services' },
        { label: serviceTitle || 'Loading…' }, // ✅ now dynamic
      ];
    }

    // Contact
    if (path === '/contact') {
      return [
        { label: 'Home', link: '/' },
        { label: 'Contact' },
      ];
    }

    // Gallery
    if (path === '/gallery') {
      return [
        { label: 'Home', link: '/' },
        { label: 'Gallery' },
      ];
    }

    return [];
  };

  

  return (
    <div className="page">
      <Header />

      <Breadcrumb items={getBreadcrumbItems()} />

      <main className="content">
        <Routes>
          <Route path="/" element={<SiteUpgrade />} />
          <Route path="/services" element={<ServicesPage />} />

          {/* ✅ PASS setter into detail page */}
          <Route
            path="/services/:slug"
            element={<ServiceDetailPage setBreadcrumbLabel={setServiceTitle} />}
          />

          <Route path="/contact" element={<ContactPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default App;